<template>
  <router-view />
</template>

<script>
import gtmSnippetMixin from '@/mixins/gtmSnippet';
import toolkitMixin from '@/mixins/toolkit';
import sessionMixin from '@/mixins/session';
import getParams from '@/util/getParams';
import { setAppUserInfoStorage } from '@/util/appUserInfoStorage';
import { setCookies } from '@/util/cookies';
export default {
  name: 'app',
  mixins: [gtmSnippetMixin, toolkitMixin, sessionMixin],
  methods: {
    // 从app进入设置用户信息
    setAppUserInfo() {
      const device = getParams('device');
      const xtoken = getParams('xtoken');
      if (device) {
        let lang = getParams('lang');
        const langMap = {
          en: 'en_US',
          zh: 'zh_CN',
          fr: 'fr_FR',
          kk: 'en_US',
          hi: 'hi',
          tw: 'zh_TW',
          in: 'id',
          vt: 'vi'
        };
        if (['en', 'zh', 'fr', 'kk', 'hi', 'tw', 'in', 'vt'].includes(lang)) {
          lang = langMap[lang];
        }
        let params = {
          appUserId: getParams('crmUserId'),
          appToken: getParams('userToken'),
          sign: getParams('sign'),
          device,
          lang,
          xtoken
        };
        setAppUserInfoStorage(params);
        setCookies('xtoken', xtoken);
      }
    }
  },
  mounted() {
    // get session id
    this.getSessionId();
    this.setAppUserInfo();
  }
};
</script>
